"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _ComponentWrapper = _interopRequireDefault(require("../../../ComponentWrapper"));

var _AccountNav = _interopRequireDefault(require("../../../AccountNav"));

var _AccountNav2 = require("../../../AccountNav/AccountNav");

var _MenuSlider = require("../MenuSlider.style");

var MenuSliderActions = function MenuSliderActions(_ref) {
  var actions = _ref.actions,
      account = _ref.account,
      variation = _ref.variation,
      toggleNav = _ref.toggleNav;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      globalNav = _ref2.globalNav;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, account && variation === 'mega' && /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: [12]
  }, /*#__PURE__*/_react.default.createElement(_AccountNav.default, {
    account: account,
    variant: "slider",
    variation: variation,
    toggleNav: toggleNav
  })), actions.length > 0 && !account && /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: [12]
  }, /*#__PURE__*/_react.default.createElement(_MenuSlider.ActionsWrap, {
    actions: actions
  }, actions && actions.map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderAction // eslint-disable-next-line react/no-array-index-key
    , Object.assign({
      key: action.label,
      variant: globalNav.sliderActionVariant,
      inverted: globalNav.sliderActionInverted,
      onClick: function onClick() {
        toggleNav();
      }
    }, action), action.label);
  }))));
};

MenuSliderActions.propTypes = {
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  account: _propTypes.default.shape(_AccountNav2.accountPropTypes),
  variation: _propTypes.default.oneOf(['mega', 'primary']),
  toggleNav: _propTypes.default.func.isRequired
};
MenuSliderActions.defaultProps = {
  actions: [],
  account: null,
  variation: 'mega'
};
var _default = MenuSliderActions;
exports.default = _default;